module.exports = __webpack_public_path__ + "static/media/icon-forward10s.d94498e4.svg";